// docs/175 — who writes a World: the profile kept on `world.storyteller` (fk-schema `storyteller`).
// Gritty and After Dark are uncensored, written by Grok: gritty may be dark, violent and gory;
// after dark is steered toward mature romance. Only a keeper whose account allows uncensored
// lobbies may choose one, and everyone sees when a World is one.
export const STORYTELLER_STANDARD = 0;
export const STORYTELLER_GRITTY = 1;
export const STORYTELLER_AFTER_DARK = 2;
/** docs/185: the published campaign, written ahead; no AI writes the World. Offered once a campaign is published. */
export const STORYTELLER_PUBLISHED = 3;

export const STORYTELLERS = [
  { value: STORYTELLER_STANDARD, label: 'Standard', about: '', uncensored: false },
  { value: STORYTELLER_GRITTY, label: 'Gritty', about: 'uncensored: dark, violent and gory', uncensored: true },
  { value: STORYTELLER_AFTER_DARK, label: 'After Dark', about: 'uncensored: steered toward mature romance', uncensored: true },
  { value: STORYTELLER_PUBLISHED, label: 'Published', about: 'the campaign written ahead: every World plays the same story, its boards its own', uncensored: false },
];

/** The storytellers a keeper may choose: uncensored ones if their account allows them, the published campaign if one is published. */
export const tellerChoices = (allowUncensored: boolean, published: boolean) =>
  STORYTELLERS.filter((t) => (t.uncensored ? allowUncensored : t.value !== STORYTELLER_PUBLISHED || published));

export const isUncensored = (w: { storyteller: number } | undefined) => !!w && !!STORYTELLERS.find((t) => t.value === w.storyteller)?.uncensored;
/** The badge an uncensored World carries in the lists and the lobby, or undefined. */
export const uncensoredLabel = (w: { storyteller: number } | undefined) => (isUncensored(w) ? STORYTELLERS.find((s) => s.value === w!.storyteller)?.label.toLowerCase() ?? 'uncensored' : undefined);
